import _extends from "@babel/runtime/helpers/extends";
import { EProductPlanAdditionalTeaching } from "@devowl-wp/api-real-commerce";
import { Checkbox, Form } from "antd";
import { observer } from "mobx-react";
import { _i, __ } from "../../../utils";
const CheckoutTerms = observer(_ref => {
  let {
    seller,
    manufacturer,
    formItemAttr = {},
    newsletter = true,
    additionalTeachings = []
  } = _ref;
  return /*#__PURE__*/React.createElement(Form.Item, _extends({
    label: __("Terms and Conditions"),
    required: true
  }, formItemAttr), /*#__PURE__*/React.createElement(Form.Item, {
    name: "terms",
    valuePropName: "checked",
    rules: [{
      type: "boolean",
      required: true,
      transform: value => value || undefined,
      message: __("Please confirm that you have read the Terms and Conditions!")
    }]
  }, /*#__PURE__*/React.createElement(Checkbox, null, _i(__("I have read and agree to the {{aSeller}}Terms and Conditions of %s{{/aSeller}} (seller) and the {{aMan}}Terms and Conditions of %s{{/aMan}} (manufacturer of the product).", seller.name, manufacturer.name), {
    aSeller: /*#__PURE__*/React.createElement("a", {
      href: seller.terms,
      target: "_blank",
      rel: "noreferrer"
    }),
    aMan: /*#__PURE__*/React.createElement("a", {
      href: manufacturer.terms,
      target: "_blank",
      rel: "noreferrer"
    })
  }))), additionalTeachings.map(_ref2 => {
    let {
      teaching
    } = _ref2;
    let requiredMessage;
    let checkboxText;
    switch (teaching) {
      case EProductPlanAdditionalTeaching.CancellationPolicy:
        requiredMessage = __("Please confirm that you have read the cancellation policy!");
        checkboxText = _i(__("I have read the {{a}}cancellation policy{{/a}}."), {
          a: /*#__PURE__*/React.createElement("a", {
            href: manufacturer.cancellation,
            target: "_blank",
            rel: "noreferrer"
          })
        });
        break;
      case EProductPlanAdditionalTeaching.ExclusionOfRevocation:
        requiredMessage = __("Please confirm that you have read the cancellation policy!");
        checkboxText = _i(__("I wish the order to be executed before the end of the legal revocation period for consumers. With the complete fulfillment of the contract (provision of the software), my right of revocation expires, which I have acknowledged in the {{a}}cancellation policy{{/a}}."), {
          a: /*#__PURE__*/React.createElement("a", {
            href: manufacturer.cancellation,
            target: "_blank",
            rel: "noreferrer"
          })
        });
        break;
      case EProductPlanAdditionalTeaching.NoLegalAdviceContractWork:
        requiredMessage = __("Please confirm that you acknowledge this!");
        checkboxText = _i(__("I acknowledge that the execution of the order is performed to the best of my knowledge and belief, but does not constitute legal advice."));
        break;
      case EProductPlanAdditionalTeaching.DpaForPayedSupport:
        requiredMessage = __("Please confirm that you acknowledge this!");
        checkboxText = _i(__("I allow access to my WordPress backend to execute the order. I have read and agree to the {{a}}data processing agreement{{/a}} for this purpose."), {
          a: /*#__PURE__*/React.createElement("a", {
            href: manufacturer.supportDpa,
            target: "_blank",
            rel: "noreferrer"
          })
        });
        break;
      default:
        return null;
    }
    const name = `additionalTeaching_${teaching}`;
    return /*#__PURE__*/React.createElement(Form.Item, {
      key: name,
      name: name,
      valuePropName: "checked",
      rules: [{
        type: "boolean",
        required: true,
        transform: value => value || undefined,
        message: requiredMessage
      }]
    }, /*#__PURE__*/React.createElement(Checkbox, null, checkboxText));
  }), /*#__PURE__*/React.createElement(Form.Item, {
    name: "privacy",
    valuePropName: "checked",
    rules: [{
      type: "boolean",
      required: true,
      transform: value => value || undefined,
      message: __("Please confirm that you have read the privacy policy!")
    }]
  }, /*#__PURE__*/React.createElement(Checkbox, null, _i(__("I have read the {{aSeller}}Privacy Policy of %s{{/aSeller}} (seller) and the {{aMan}}Privacy Policy of %s{{/aMan}} (manufacturer of the product).", seller.name, manufacturer.name), {
    aSeller: /*#__PURE__*/React.createElement("a", {
      href: seller.privacy,
      target: "_blank",
      rel: "noreferrer"
    }),
    aMan: /*#__PURE__*/React.createElement("a", {
      href: manufacturer.privacy,
      target: "_blank",
      rel: "noreferrer"
    })
  }))), newsletter && /*#__PURE__*/React.createElement(Form.Item, {
    name: "newsletter",
    valuePropName: "checked"
  }, /*#__PURE__*/React.createElement(Checkbox, null, __("I would like to receive the %s newsletter with WordPress news, sales and product offers (approx. 1-2 per month) via email. I know that I can withdraw my consent for the newsletter at any time.", manufacturer.name))));
});
export { CheckoutTerms };